import { Box } from "@mui/material";
import { v2 } from "../ui/v2Tokens";
import V2Dialog from "../ui/V2Dialog";
import { TextButton } from "../ui/primitives";

type Props = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  /** an extra middle button, e.g. "save and leave" */
  extraAction?: { label: string; onClick: () => void };
};

/** Guard for actions that destroy something the trainer can't get back. */
const ConfirmDialog = ({
  open,
  onClose,
  onConfirm,
  title,
  message,
  confirmLabel = "מחק",
  cancelLabel = "ביטול",
  extraAction,
}: Props) => (
  <V2Dialog
    open={open}
    onClose={onClose}
    title={title}
    maxWidth="440px"
    actions={
      <>
        <TextButton onClick={onClose}>{cancelLabel}</TextButton>
        <Box sx={{ display: "flex", gap: "8px" }}>
          {extraAction && (
            <TextButton tone="green" onClick={extraAction.onClick}>
              {extraAction.label}
            </TextButton>
          )}
          <TextButton tone="danger" onClick={onConfirm}>
            {confirmLabel}
          </TextButton>
        </Box>
      </>
    }
  >
    <Box sx={{ fontSize: "13px", color: v2.ink2, lineHeight: 1.7 }}>{message}</Box>
  </V2Dialog>
);

export default ConfirmDialog;
